'use client';

import { Text } from '@/shared/ui/core';
import cn from 'classnames';
import { ComponentRef, forwardRef } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { TooltipProps } from '../model/tooltip.types';
import styles from './tooltip.module.scss';


export const Tooltip = forwardRef<ComponentRef<typeof TooltipPrimitive.Content>, TooltipProps>(function Tooltip ({
    className,
    content = '',
    children,
    delayDuration = 200,
    withArrow = true,
    sideOffset = 6,
    ...props
}, ref) {
    return (
        <TooltipPrimitive.Provider delayDuration={ delayDuration }>
            <TooltipPrimitive.Root>
                <TooltipPrimitive.Trigger asChild>
                    { children }
                </TooltipPrimitive.Trigger>
                <TooltipPrimitive.Portal>
                    <TooltipPrimitive.Content
                        ref={ ref }
                        sideOffset={ sideOffset }
                        className={ cn(styles.content, className) }
                        { ...props }
                    >
                        <Text
                            dangerouslySetInnerHTML={{ __html: content }}
                        />

                        {
                            withArrow &&
                            <TooltipPrimitive.Arrow className={ styles.arrow }/>
                        }
                    </TooltipPrimitive.Content>
                </TooltipPrimitive.Portal>
            </TooltipPrimitive.Root>
        </TooltipPrimitive.Provider>
    );
});
